// extracted by mini-css-extract-plugin
export default {"wrapper":"ModeSwitch_wrapper__xAWfx","modeOne":"ModeSwitch_modeOne__UmWPU","highlighter":"ModeSwitch_highlighter__AjfX6","modeTwo":"ModeSwitch_modeTwo__uZr9y"};